module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-5.07d7547d.png";